import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import {
  InputTextArea,
  InputTextMaster,
  MasterButton,
  Modal,
} from "App/Component/ui";
import {
  DISABLED_BUTTON_SUBMIT,
  DEFAULT_SHOW_BUTTON_SUBMIT,
  instance3,
} from "App/constants";
import {
  isNull,
  titleModal,
  today,
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  convertToValidPrice,
  oneMonthBeforeToday,
} from "App/utils/helpers";
import { accessCode } from "utils/all";

export const STATUS_RETUR_OPEN = 0;
export const STATUS_RETUR_PROSSES = 1;

export const RESET_STATE_RETUR_PENJUALAN = {
  id: "",
  penjualan_id: "",

  gudang_id: null,
  gudang_name: "Pilih Gudang",
  tanggal_retur: today(),
  keterangan_retur: "",

  tanggal_kas_masuk: today(),
  kas_id: null,
  kas_name: "Pilih Kas",
  harga2: "",

  status_retur: STATUS_RETUR_OPEN,
};

export const RESET_STATE_RETUR_ITEM = {
  id: "",
  barang_id: "",
  jumlah_barang: "",
  retur_penjualan_id: "",
  keterangan_item: "",
  harga_pokok2: "",
};

export const RESET_STATE_FORM_FILTER = {
  id: "",
  tanggal_awal: oneMonthBeforeToday(),
  tanggal_akhir: today(),
  kas_id: null,
  kas_name: "Pilih Kas",
  gudang_id: null,
  gudang_name: "Pilih Gudang",

  pages: 1,
  limit: 10,
};

export const urlGetGudang = `/wmsfarmasi/gudang/list?access_code=${accessCode.gudang_farmasi}`;
export const urlGetKasBank = "/kas/kas/list";
export const urlAddReturPenjualan = "/returPenjualan/registerProfil";
export const urlUpdateReturPenjualan = "/returPenjualan/updateProfil";

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    align: "left",
  },
  {
    id: "penjualan_id",
    disablePadding: true,
    label: "PENJUALAN ID",
    align: "left",
    minWidth: "130px",
  },
  {
    id: "tanggal_retur",
    disablePadding: true,
    label: "TGL RETUR",
    align: "left",
    minWidth: "130px",
  },
  {
    id: "tanggal_kas_masuk",
    disablePadding: true,
    label: "TGL KAS MASUK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nama_gudang",
    disablePadding: true,
    label: "GUDANG",
    align: "left",
    minWidth: "130px",
  },
  {
    id: "kas_name",
    disablePadding: true,
    label: "KAS",
    align: "left",
    minWidth: "130px",
  },
  {
    id: "harga_retur",
    disablePadding: true,
    label: "HARGA",
    align: "left",
  },
  {
    id: "keterangan_retur",
    disablePadding: true,
    label: "KETERANGAN",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status_retur",
    disablePadding: true,
    label: "STATUS",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const getListItemRetur = async (ID) => {
  try {
    const api = await instance3.get(
      `/returPenjualan/listItemsByreturPenjualanId/${ID}`
    );

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
      };
    } else {
      return {
        state: false,
        data: [],
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deleteReturItemByID = async (id) => {
  try {
    const api = await instance3.post("/returPenjualan/deleteItem", {
      id,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus retur item",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const deleteReturPenjualanByID = async (id) => {
  try {
    const api = await instance3.post("/returPenjualan/deleteProfil", {
      id,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus retur",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const getByFilterReturPenjualan = async (formFilter, pages, limit) => {
  try {
    const api = await instance3.post("/returPenjualan/list", {
      halaman: pages,
      jumlah: limit,
      id: formFilter.id,
      gudang_id: formFilter.gudang_id,
      tanggal_awal: formFilter.tanggal_awal,
      tanggal_akhir: formFilter.tanggal_akhir,
      kas_id: formFilter.kas_id,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getPenjualanItem = async (id) => {
  try {
    const api = await instance3.get(
      `/returPenjualan/listReturBarangByPenjualanId/${id}`
    );

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
      };
    } else {
      return {
        state: false,
        data: [],
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const ModalItemRetur = ({
  formItem,
  setFormItem,
  setShowModal,
  fetchDataReturItem,
}) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const handleChange = (text) => (e) => {
    setFormItem({
      ...formItem,
      [text]: e.target.value,
    });
  };

  const add = async () => {
    return instance3.post("/returPenjualan/registerItem", {
      ...formItem,
      harga_pokok: convertToValidPrice(formItem.harga_pokok2),
      total_harga_barang:
        convertToValidPrice(formItem.harga_pokok2) * formItem.jumlah_barang,
    });
  };

  const update = async () => {
    return instance3.post("/returPenjualan/updateItem", {
      ...formItem,
      harga_pokok: convertToValidPrice(formItem.harga_pokok2),
      total_harga_barang:
        convertToValidPrice(formItem.harga_pokok2) * formItem.jumlah_barang,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    if (isNull(formItem.retur_penjualan_id)) {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Buka Transaksi terlebih dahulu");
    } else {
      try {
        if (formItem.id === "") {
          await add();
          defaultToastSuccess("Berhasil menambah data");
          await fetchDataReturItem();
          setShowModal(false);
        } else if (formItem.id !== "") {
          await update();
          defaultToastSuccess("Berhasil mengubah data");
          await fetchDataReturItem();
          setShowModal(false);
        }
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        setFormItem(RESET_STATE_RETUR_ITEM);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChangeRupiah = (text) => (e) => {
    let val = e.target.value;
    if (!isNull(val)) {
      setFormItem({
        ...formItem,
        [text]: formatRupiah(val),
      });
    } else {
      setFormItem({
        ...formItem,
        [text]: val,
      });
    }
  };

  return (
    <Modal
      title={`${titleModal(formItem.id)} Retur`}
      width='20%'
      show={setShowModal}>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <InputTextMaster
              name='jumlah_barang'
              label='BANYAK'
              id='jumlah_barang'
              placeholder='0'
              value={formItem.jumlah_barang}
              onChange={handleChange("jumlah_barang")}
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='harga_pokok2'
              label='HARGA POKOK'
              id='harga_pokok2'
              placeholder='Harga Pokok'
              value={formItem.harga_pokok2}
              onChange={handleChangeRupiah("harga_pokok2")}
            />
          </Grid>
          <Grid item sm={12}>
            <InputTextArea
              label={"KETERANGAN"}
              placeholder={"Keterangan"}
              name='keterangan_item'
              value={formItem.keterangan_item}
              onChange={handleChange("keterangan_item")}
              id='keterangan_item'
              rows={"3"}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
